import { render, staticRenderFns } from "./master-item.vue?vue&type=template&id=55bea3e6&scoped=true"
import script from "./master-item.vue?vue&type=script&lang=js"
export * from "./master-item.vue?vue&type=script&lang=js"
import style0 from "./master-item.vue?vue&type=style&index=0&id=55bea3e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bea3e6",
  null
  
)

export default component.exports